import { render, staticRenderFns } from "./bak.vue?vue&type=template&id=682fd194&scoped=true&"
import script from "./bak.vue?vue&type=script&lang=js&"
export * from "./bak.vue?vue&type=script&lang=js&"
import style0 from "./bak.vue?vue&type=style&index=0&id=682fd194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682fd194",
  null
  
)

export default component.exports